import { prop } from 'ramda'

export const chapters = prop('chapters')
export const audio = prop('audio')
export const share = prop('share')
export const files = prop('files')
export const shownotes = prop('shownotes')
export const transcripts = prop('transcripts')
export const playlist = prop('playlist')
